module.exports = __webpack_public_path__ + "img/nstarx.fd06eedd.png";